import { computed } from 'vue';
import { blue, lime, red } from '../colorsPreset.js';

const themeColorPreset = {
    red, lime, blue,
};

const useThemes = ({ settings }) => {
    const activeTheme = computed(() => {
        return settings.value.colorScheme ?? 'custom';
    });

    const widgetColors = computed(() => ({
        '--lw-title': themeColorPreset[activeTheme.value]?.colorTitle || settings.value.colorTextBlocks,
        '--lw-text': themeColorPreset[activeTheme.value]?.colorText || settings.value.colorTextBlocks,
        '--lw-widget-bg': themeColorPreset[activeTheme.value]?.widgetBg || settings.value.colorWidgetBackground,
        '--lw-btn-shadow': themeColorPreset[activeTheme.value]?.btnShadow || 'none',
        '--lw-btn-bg': themeColorPreset[activeTheme.value]?.btnBg || settings.value.colorButtonBackground,
        '--lw-btn-color': themeColorPreset[activeTheme.value]?.btnColor || settings.value.colorButtonText,
        '--lw-btn-hover-color': themeColorPreset[activeTheme.value]?.btnHoverColor || settings.value.colorButtonTextHover,
        '--lw-btn-hover-bg': themeColorPreset[activeTheme.value]?.btnHoverBg || settings.value.colorButtonBackgroundHover,
        '--lw-btn-active-color': themeColorPreset[activeTheme.value]?.btnActiveColor || settings.value.colorButtonTextClick,
        '--lw-btn-active-bg': themeColorPreset[activeTheme.value]?.btnActiveBg || settings.value.colorButtonBackgroundClick,
        '--lw-btn-icon-color': themeColorPreset[activeTheme.value]?.btnIconColor || 'inherit',
        '--lw-font-family': settings.value.fontFamily,
    }));

    return { widgetColors };
};

export default  useThemes;
